$(document).ready(function () {
    $('#query-filter').on('submit', function (e) {
        e.preventDefault();

        let urlParams = new URLSearchParams(window.location.search);
        $(this).find('input[name], select[name], textarea[name]').each(function () {
            let name = $(this).attr('name');
            let value = $(this).val();

            if (value) {
                urlParams.set(name, value.trim());
            } else {
                urlParams.delete(name);
            }
        });

        window.location.href = urlParams.toString() ? `${window.location.pathname}?${urlParams}` : window.location.pathname;
    });

    $('.select-search select[name="sort"]').on('change', function () {
        let urlParams = new URLSearchParams(window.location.search);
        urlParams.set("sort", $(this).val());
        for (let param of urlParams.keys()) {
            if (!urlParams.get(param) || urlParams.get(param).trim() === "") {
                urlParams.delete(param);
            }
        }

        window.location.href = urlParams.toString() ? `${window.location.pathname}?${urlParams}` : window.location.pathname;
    });

    $('.tab-menu-item').on('click', function () {
        let value = $(this).data('value');
        let key = $(this).data('key');
        let urlParams = new URLSearchParams(window.location.search);

        if (value !== undefined) {
            urlParams.set(key, value);
        }

        for (let param of urlParams.keys()) {
            if (!urlParams.get(param) || urlParams.get(param).trim() === "") {
                urlParams.delete(param);
            }
        }

        window.location.href = urlParams.toString() ? `${window.location.pathname}?${urlParams}` : window.location.pathname;

        $('select[name="' + key + '"]').val(value).trigger('change');
        $('.tab-menu-item').removeClass('active');
        $(this).addClass('active');
    });

    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function highlightAllText(element, searchText) {
        if (!searchText || !element) return;
        const regex = new RegExp(escapeRegExp(searchText), 'gi');
        const highlightClass = 'highlight';
        const textNodeType = Node.TEXT_NODE;
        const elementNodeType = Node.ELEMENT_NODE;
        const stack = [element];

        while (stack.length) {
            const node = stack.pop();
            if (node.nodeType === elementNodeType && node.classList.contains(highlightClass)) {
                continue;
            }
            if (node.nodeType === textNodeType) {
                const text = node.nodeValue;
                if (!text.trim()) continue;

                const parent = node.parentNode;
                let lastIndex = 0;
                let match;
                let hasMatches = false;
                const fragment = document.createDocumentFragment();
                regex.lastIndex = 0;

                while ((match = regex.exec(text)) !== null) {
                    hasMatches = true;
                    if (match.index > lastIndex) {
                        fragment.appendChild(document.createTextNode(
                            text.substring(lastIndex, match.index)
                        ));
                    }
                    const span = document.createElement('span');
                    span.className = highlightClass;
                    span.textContent = match[0];
                    fragment.appendChild(span);
                    lastIndex = regex.lastIndex;
                    if (match.index === lastIndex) regex.lastIndex++;
                }

                if (hasMatches) {
                    if (lastIndex < text.length) {
                        fragment.appendChild(document.createTextNode(
                            text.substring(lastIndex)
                        ));
                    }
                    parent.replaceChild(fragment, node);
                }
            } else if (node.childNodes && node.childNodes.length) {
                for (let i = node.childNodes.length - 1; i >= 0; i--) {
                    stack.push(node.childNodes[i]);
                }
            }
        }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const searchText = urlParams.get('txtSearch') || urlParams.get('txtTags');

    if (searchText) {
        const decodedSearchText = decodeURIComponent(searchText.replace(/\+/g, ' '));
        const contentWrapper = document.querySelector('.news-container-remaining-list-wrapper');

        if (contentWrapper) {
            highlightAllText(contentWrapper, decodedSearchText);
        }
    }
});
